import * as D from 'io-ts/lib/Decoder'
import { Literal } from 'io-ts/lib/Schemable'

const enum_ = <A extends ReadonlyArray<Literal>>(...members: A): D.Decoder<A[number]> =>
    D.union(...members.map(e => D.literal(e)))

const decodeAt = <T>(prop: string, decoder: D.Decoder<T>): D.Decoder<T> => ({
    decode: (value: any) => decoder.decode(value[prop]),
})

const withDefault = <T>(defaultValue: T, decoder: D.Decoder<T>): D.Decoder<T> => ({
    decode: (value: any) => (value ? decoder.decode(value) : D.success(defaultValue)),
})

export { enum_, decodeAt, withDefault }
